import React, { Component } from 'react';
import Modalviewer from '../../Modals/Modalviewer';

require('./templateTheme.css');
var Modal = require('boron/WaveModal');
var style = {
    modalStyle: {
        width: '80%',
        height: 'auto',
        padding: '20px',
    }
};

class NitaRanaTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: ''
        };
    }

    showModal = (typeString) => {
        console.log("Type of Modal to open: " + typeString);
        this.setState({
            modalType: typeString
        });
        this.refs.detailModal.show();
    }

    render() {
        return (
            <div>
                <div className="card generalCard">
                    <img className="card-header"
                        style={{ marginRight: 'auto', marginLeft: 'auto', border: 'none', backgroundColor: 'transparent', textAlign: 'center', maxWidth: '200px', maxHeight: '100px' }}
                        alt="Company Logo"
                        src="https://firebasestorage.googleapis.com/v0/b/tinqertinquer.appspot.com/o/Clients%2FNeetaRana%2Foptum-logo.png?alt=media&token=73adc378-9053-4d4f-b542-c968daa67adf" />

                    <img className="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/tinqertinquer.appspot.com/o/Clients%2FNeetaRana%2FSkincareModel.jpeg?alt=media&token=4734fa59-7930-4372-93ca-c2db816e1d74" alt="Skincare Model"
                        style={
                            {
                                boxShadow: '0rem 1.75rem 3.125rem 1.25rem rgba(0,0,0,0.059)',
                                borderRadius: '10px',
                            }
                        } />
                    <div className="card-body" style={{ textAlign: 'center' }}>
                        <h4 className="card-text">Get Your Voucher For A Custom Skintype Analysis, Consultation, and 20 Units of <b>Xeomin</b>/<b>Botox</b> For Only $139!</h4>
                        <hr />
                        <h5 className="card-text">Be sure to hurry! Only <b>17</b> vouchers are remaining and time is running out!</h5>
                        <button className="btn btn-outline-primary linkButton"
                            onClick={() => this.showModal("NeetaRana")}
                        >SEND ME MY VOUCHER!<span>  </span>
                            <i className="fas fa-forward"></i>
                        </button>
                        <br />
                        <small>100% Secure. We never share your info!</small>
                    </div>
                </div>
                <Modal id="modal_id" ref='detailModal' modalStyle={style.modalStyle}>
                    <Modalviewer modalType={this.state.modalType} />
                </Modal>
            </div>
        );
    }
}

export default NitaRanaTemplate;


// WEBPACK FOOTER //
// ./src/Clients/NitaRana/NitaRanaTemplate.js